import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { useGetQuestionCompletedQuery } from "../../../graphql/generated.tsx";
import { GrCircleInformation } from "react-icons/gr";
import Loader from "../../../components/Loader.jsx";

ChartJS.register(ArcElement, Tooltip, Legend);

const StudentCourseProgression = ({ studentData, isAdmin, paidDashboard }) => {
  const student_id = studentData ? studentData.id : null;
  const isPaidCourseView = typeof paidDashboard === "boolean" ? !paidDashboard : false;

  const {
    data: studentQuestion,
    loading,
    error,
  } = useGetQuestionCompletedQuery({
    variables: { student_id, is_paid: isPaidCourseView },
    skip: !student_id,
  });


  const isDataAvailable =
    studentQuestion &&
    studentQuestion.getQuestionCompleted &&
    studentQuestion.getQuestionCompleted.easy &&
    studentQuestion.getQuestionCompleted.medium &&
    studentQuestion.getQuestionCompleted.hard;

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[345px]">
       <Loader />
      </div>
    );
  }

  if (error || !isDataAvailable) {
    return (
      <div className="flex justify-center items-center min-h-[345px] text-red-500">
        No data available
      </div>
    );
  }

  const donutData = {
    labels: ["Easy", "Medium", "Hard"],
    datasets: [
      {
        data: [
          studentQuestion?.getQuestionCompleted?.easy?.completed || 0,
          studentQuestion?.getQuestionCompleted?.medium?.completed || 0,
          studentQuestion?.getQuestionCompleted?.hard?.completed || 0,
        ],
        backgroundColor: ["#0E5B54", "#5B2E0E", "#0E3B5B"],
        hoverBackgroundColor: ["#0E5B54", "#5B2E0E", "#0E3B5B"],
      },
    ],
  };

  const donutOptions = {
    cutout: "80%",
    plugins: {
      legend: {
        display: false,
      },
    },
    interaction: {
      mode: "nearest",
    },
  };

  const totalCompleted =
    (studentQuestion?.getQuestionCompleted?.easy?.completed || 0) +
    (studentQuestion?.getQuestionCompleted?.medium?.completed || 0) +
    (studentQuestion?.getQuestionCompleted?.hard?.completed || 0);

  const percentage = totalCompleted;

  if (totalCompleted === 0) {
    return (
      <>
        <div
          className="flex flex-col items-center justify-center w-full px-5 py-8 bg-white rounded-md"
          style={{ height: "345px" }}
        >
          <GrCircleInformation className="w-10 h-10 text-primary" />
          <div className="p-5 text-lg font-semibold text-center text-primary">
            {isAdmin
              ? "This student has not yet started the course. Please encourage them to take the first step!"
              : "Start your learning journey today! Track your progress as you engage with the course material and achieve your goals."}
          </div>
        </div>
      </>
    );
  }

  return (
    <div
      className="flex flex-col items-center w-full py-8 bg-white rounded-lg px-28 max-md:px-2"
      style={{ height: "345px" }}
    >
      <div
        className="relative flex items-center justify-center w-full mb-5"
        style={{ height: "200px" }}
      >
        <Doughnut data={donutData} options={donutOptions} />
        <div className="absolute flex flex-col items-center justify-center text-xl font-bold text-gray-800">
          {percentage}
          <br />
          <span className="text-sm font-light">Questions Solved</span>
        </div>
      </div>

      <div className="flex justify-around w-full">
        <div className="text-center">
          <div className="text-lg font-bold">
            {studentQuestion?.getQuestionCompleted?.easy?.completed || 0} /{" "}
            {studentQuestion?.getQuestionCompleted?.easy?.total || 0}
          </div>
          <div className="mt-1 text-xs text-gray-500">
            <span
              className="inline-block px-2 py-1 text-white rounded-md"
              style={{ backgroundColor: "#0E5B54" }}
            >
              Easy
            </span>
          </div>
        </div>
        <div className="text-center">
          <div className="text-lg font-bold">
            {studentQuestion?.getQuestionCompleted?.medium?.completed || 0} /{" "}
            {studentQuestion?.getQuestionCompleted?.medium?.total || 0}
          </div>
          <div className="mt-1 text-xs text-gray-500">
            <span
              className="inline-block px-2 py-1 text-white rounded-md"
              style={{ backgroundColor: "#5B2E0E" }}
            >
              Medium
            </span>
          </div>
        </div>
        <div className="text-center">
          <div className="text-lg font-bold">
            {studentQuestion?.getQuestionCompleted?.hard?.completed || 0} /{" "}
            {studentQuestion?.getQuestionCompleted?.hard?.total || 0}
          </div>
          <div className="mt-1 text-xs text-gray-500">
            <span
              className="inline-block px-2 py-1 text-white rounded-md"
              style={{ backgroundColor: "#0E3B5B" }}
            >
              Hard
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentCourseProgression;
